import './inline-title.component.scss';

import { useTranslation } from 'react-i18next';
import { memo }from 'react';

import Hr from '../Hr';

const InlineTitle = props => {
  const {
    className,
    label,
    isNonUnderline,
    isShortUnderline,
    children,
    ...other
  } = props;
  const { t } = useTranslation();

  return (
    <div className='inline-title-container'>
      <div className={`d-flex title-container ${className}`} {...other}>
        <div className='d-flex align-items-center inline-title'> {t(label)} </div>
        <div className='d-flex ms-auto inline-children'>
          {children}
        </div>
      </div>
      <Hr className={!isNonUnderline && !isShortUnderline ? 'show' : 'hide'}/>
      <div className={`short-under-line-container ${!isNonUnderline && isShortUnderline ? 'show' : 'hide'}`}/>
    </div>
  );
};

InlineTitle.defaultProps = {
  isNonUnderline: false,
  isShortUnderline: false
}

export default memo(InlineTitle);